export default {
    title: "Digital Demo Studio",
    userMenu: {
        home: "@:navigation.home",
        editProfile: "@:navigation.editProfile",
        logout: "@:navigation.logout"
    },
    support: "Support"
}